import { render, staticRenderFns } from "./ChangeCompareGroup.vue?vue&type=template&id=504d7a6f&scoped=true&"
import script from "./ChangeCompareGroup.vue?vue&type=script&lang=js&"
export * from "./ChangeCompareGroup.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCompareGroup.vue?vue&type=style&index=0&id=504d7a6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504d7a6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
